import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateHoroscope = () => {
  const history = useHistory();
  let { id } = useParams();

  const [data, setData] = useState({
    userId: id,
    raasi: "",
    star: "",
    dhosam: "",
    horoNecessary: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData({
      ...data,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    api.post("/admin/manageUserProfile/addHoroscope", data).then((res) => {
      Swal.fire(res.data.data).then(() => {
        history.goBack();
      });
    });
  };

  useEffect(() => {
    if (id) {
      api.post("admin/adminDashboard/userFullDetails", { id }).then((res) => {
        if (res.data.data !== "Data not found") {
          const horoscope = res.data.data.horoscopeDetails;
          setData({
            userId: id,
            raasi: horoscope.raasi || "",
            star: horoscope.star || "",
            dhosam: horoscope.dhosam || "",
            horoNecessary: horoscope.horoNecessary || false,
          });
        }
      });
    }
  }, [id]);

  return (
    <div className="content">
      <h3>Update Horoscope Details</h3>
      <Form onSubmit={handleSubmit} className="pt-3">
        <FormGroup>
          <Label for="raasi">Raasi</Label>
          <Input
            type="text"
            name="raasi"
            id="raasi"
            value={data.raasi}
            onChange={handleChange}
            placeholder="Enter Raasi"
          />
        </FormGroup>

        <FormGroup>
          <Label for="star">Star</Label>
          <Input
            type="text"
            name="star"
            id="star"
            value={data.star}
            onChange={handleChange}
            placeholder="Enter Star"
          />
        </FormGroup>

        <FormGroup>
          <Label for="dhosam">Dhosam</Label>
          <Input
            type="text"
            name="dhosam"
            id="dhosam"
            value={data.dhosam}
            onChange={handleChange}
            placeholder="Enter Dhosam"
          />
        </FormGroup>

        <FormGroup check>
          <Input
            type="checkbox"
            name="horoNecessary"
            id="horoNecessary"
            checked={data.horoNecessary}
            onChange={handleChange}
          />
          <Label check>Horoscope Necessary</Label>
        </FormGroup>

        <Button style={{ marginTop: "20px", background: "black" }}>
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default UpdateHoroscope;
